import { UserActionTypes } from "../models";
import { RESET_USER } from "../types";

export default (): UserActionTypes => ({
    type: RESET_USER,
});